import React, { Component } from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

class AddParty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      esaId: '',
      shortCode: '',
    };
  }

  render() {
    const {
      open,
      handleCancel,
      handleAccept,
      classes,
      onEnter,
      committee,
    } = this.props;
    const { name, esaId, shortCode } = this.state;

    return (
      <MuiDialog
        open={open}
        onEnter={onEnter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Legg til ${committee ? 'utvalg' : 'parti'}`}</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogcontent}>
            {`${committee ? 'Utvalget vil lagres i utvalgslisten'
              : 'Partiet vil lagres i partilisten'} og dermed være tilgjengelig for alle.`}
          </DialogContentText>
          <TextField
            id="name"
            label={`Navn på ${committee ? 'utvalg' : 'parti'}`}
            type="text"
            variant="outlined"
            value={name}
            className={classes.textfield}
            onChange={e => this.setState({ name: e.target.value })}
          />
          {committee && [
            <TextField
              id="esaId"
              key="esaId"
              label="ESA-ID for utvalget"
              type="text"
              variant="outlined"
              value={esaId}
              className={classes.textfield}
              onChange={e => this.setState({ esaId: e.target.value })}
            />,
            <TextField
              id="shortCode"
              key="shortCode"
              label="Kort kode for utvalget"
              type="text"
              variant="outlined"
              value={shortCode}
              className={classes.textfield}
              onChange={e => this.setState({ shortCode: e.target.value })}
            />,
          ]}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCancel}>
            Avbryt
          </Button>
          <Button
            variant="contained"
            onClick={() => { handleAccept(name, esaId, shortCode); this.setState({ name: '', esaId: '', shortCode: '' }); }}
            color="primary"
          >
            Lagre
          </Button>
        </DialogActions>
      </MuiDialog>
    );
  }
}

const styles = () => ({
  dialogcontent: {
    marginBottom: '0.5rem',
  },
  textfield: {
    minWidth: '15rem',
    display: 'block',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
});

AddParty.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  handleAccept: PropTypes.func,
  classes: PropTypes.any.isRequired,
  onEnter: PropTypes.func,
  committee: PropTypes.bool,
};

AddParty.defaultProps = {
  handleCancel: () => {},
  handleAccept: () => {},
  onEnter: () => {},
  committee: false,
};

export default withStyles(styles)(AddParty);
